<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800" v-if="isEdit">Editar Curso</h1>
      <h1 class="h3 mb-2 text-gray-800" v-else>Crear Curso</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">

        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">
              <div class="col-6">
                  <b-form-group label="Título" label-for="keyInput" >
                    <b-form-input id="keyInput"  v-model="form.title" required ></b-form-input>
                  </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Descripcion" label-for="keyInput" >
                  <b-form-input id="keyInput"  v-model="form.description" required ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
              <b-form-group
                id="input-group-3"
                label="Gráfica:"
                label-for="imagen"
              >
                <b-form-file
                  accept="image/jpeg, image/png, image/jpg, image/svg+xml"
                  id="graph"
                  v-on:change="handleFilesUpload($event)"
                  v-model="form.icon"
                  :placeholder="
                      this.form.icon
                        ? this.form.icon
                        : 'Seleccione una imágen en formato PNG, JPG o SVG.'
                    "
                ></b-form-file>
                <b-img
                  v-if="this.form.icon"
                  :src="this.form.icon"
                  fluid
                  alt="icon"
                  style="
                        width: 350px;
                        margin-bottom: 25px;
                        margin-top: 10px;
                      "
                ></b-img>

              </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group label="Descripcion detallada" label-for="keyInput" >
                  <b-form-textarea 
                    id="keyInput" 
                    v-model="form.longDescription"
                    rows="3"
                    max-rows="16"
                    required
                  ></b-form-textarea>
                </b-form-group>
              </div>
              
              <div class="col-6" v-if="isEdit">
                <input
                  type="checkbox"
                  v-model="form.examRequired"
                  :class="{ 'checked': form.examRequired }"
                />
                <span class="span-diagnostic">Exámen Diagnóstico obligatorio</span>
              </div>

              <div class="col-6" v-if="isEdit">
                <input
                  type="checkbox"
                  v-model="form.isPremium"
                  :class="{ 'checked': form.isPremium }"
                />
                <span class="span-diagnostic">Es curso premium</span>
              </div>
            </div>
            <b-button type="submit" variant="primary">Guardar</b-button>
          </b-form>
        </div>
      </div>
    </div>

    <!-- add lessons (section-based) -->
    <div class="container-fluid" v-if="isEdit">
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons d-flex justify-content-between align-items-center flex-wrap">
            <h3>Lecciones:</h3>
            <button class="btn btn-outline-primary" @click="addSection">
              <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar sección
            </button>
          </div>
          <br>

          <div v-for="section in sectionsForDisplay" :key="section.id || 'default'" class="card mb-3 border">
            <div class="card-header d-flex align-items-center justify-content-between py-2">
              <div class="d-flex align-items-center flex-grow-1">
                <template v-if="section.id && editingSectionId === section.id">
                  <input
                    type="text"
                    v-model="editingSectionTitle"
                    class="form-control form-control-sm mr-2"
                    style="max-width: 280px;"
                    @keyup.enter="submitSectionTitle(section.id)"
                  />
                  <button class="btn btn-sm btn-primary mr-1" @click="submitSectionTitle(section.id)">Guardar</button>
                  <button class="btn btn-sm btn-secondary" @click="editingSectionId = null">Cancelar</button>
                </template>
                <template v-else>
                  <h5 class="mb-0">{{ section.title }}</h5>
                  <button v-if="section.id" class="btn btn-sm btn-link ml-2" @click="startEditSectionTitle(section)">Editar</button>
                </template>
              </div>
              <div class="d-flex align-items-center">
                <button class="btn btn-primary btn-sm" @click="showModal2(section.id)">
                  <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar lección
                </button>
                <button v-if="section.id && sectionsForDisplay.length > 1" class="btn btn-sm btn-outline-danger ml-2" @click="deleteSectionConfirm(section.id)">
                  Eliminar sección
                </button>
              </div>
            </div>
            <div class="card-body py-2">
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th>Título</th>
                    <th style="width: 120px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="lesson in (section.lessons || [])" :key="lesson.id">
                    <td>{{ lesson.title }}</td>
                    <td>
                      <button class="btn btn-secondary btn-sm" @click="deleteLesson(lesson.id)">
                        Eliminar
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!section.lessons || section.lessons.length === 0">
                    <td colspan="2" class="td-nhd text-muted">No hay lecciones en esta sección.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <LessonsAdd ref="lessonAddComponent" @saveLesson="onSaveLesson"/>

    </div>
    <!-- /add lessons-->



    <!-- add Simulacrums-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
      <div id="app" class="container">
        <div class="div-lessons">
          <h3>Simulacros:</h3>
          <button class="btn btn-primary"  @click="showModal()">
            <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Simulacros
          </button>
        </div>


        <br>
        <br>


        <table class="table">
          <thead>
            <tr >
              <th>Titulo</th>
              <th>Duración</th>
            </tr>
          </thead>

          <tbody v-for="simulacruModules in simulacrumsModule.simulacrums" :key="simulacruModules.id">
            <tr >
              <td>{{ simulacruModules.title}}</td>
              <td>{{ simulacruModules.duration}}</td>
              <td>
                <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                 v-on:click="deleteSimulacrum(simulacruModules.id)">
                      Eliminar
                </button>
              </td>
            </tr>
          </tbody>

          <tbody v-if="lessonsModule.lessons && lessonsModule.lessons.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>



    <b-modal no-close-on-backdrop ref="my-modal" size="xl" hide-footer title="Simulacros" v-on:hide="onModalHide">

      <div class="lessons-model">
        <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por titulo"
        aria-label="Search" aria-describedby="basic-addon2" v-model="searchSimulacrums"  v-on:keyup="loadSimulacrums">
      </div>

      <div class="lessons-model">
        <table class="table">
          <thead>
            <tr>
              <th>Titulo</th>
              <th>Duración</th>
            </tr>
          </thead>
          <tbody v-for="(simulacrum, index) in simulacrumsItems" :key="index">
            <tr>
              <td>{{ simulacrum.title }}</td>
              <td>{{ simulacrum.duration }}</td>
              <td><div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                <b-button class="btn btn-secondary" v-on:click="saveSimulacrum(simulacrum.id, )"
                block>Agregar</b-button>
              </div></td>
            </tr>
          </tbody>

          <tbody v-if="simulacrumsItems.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
          </tbody>
        </table>
      </div>

    </b-modal>


    </div>
     <!-- /add Simulacrums-->

    <!-- add practices-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons">
            <h3>Prácticas:</h3>
            <button class="btn btn-primary"  @click="showModal3()">
              <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Práctica
            </button>
          </div>


          <br>
          <br>


          <table class="table">
            <thead>
            <tr >
              <th>Titulo</th>
              <th>Descripcción</th>
            </tr>
            </thead>
            <tbody v-for="practices in lessonsModule.practices" :key="practices.id">
            <tr>
              <td>{{ practices.title}}</td>
              <td>{{ practices.text}}</td>
              <td>
                <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                        v-on:click="deletePractice(practices.id)">
                  Eliminar
                </button>
              </td>
            </tr>
            </tbody>

            <tbody v-if="lessonsModule.practices && lessonsModule.practices.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>



      <b-modal no-close-on-backdrop ref="my-modal2" size="xl" hide-footer title="Prácticas" v-on:hide="onModalHide">

        <div class="lessons-model">
          <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por titulo"
                 aria-label="Search" aria-describedby="basic-addon2" v-model="SearchPractices"  v-on:keyup="loadPractices">
        </div>

        <div class="lessons-model">
          <table class="table">
            <thead>
            <tr>
              <th>Titulo</th>
              <th>Descripcción</th>
            </tr>
            </thead>
            <tbody v-for="(practice, index) in practices" :key="index">
            <tr>
              <td>{{ practice.title }}</td>
              <td>{{ practice.text }}</td>
              <td><div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                <b-button class="mt-3" v-on:click="savePractice(practice.id, )"
                          block>Agregar</b-button>
              </div></td>
            </tr>
            </tbody>

            <tbody v-if="lessonsModule.practices && lessonsModule.practices.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
            </tbody>
          </table>
        </div>

      </b-modal>

    </div>
    <!-- /add practices-->

    <!-- add exams-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons">
            <h3>Exámenes:</h3>
            <button class="btn btn-primary"  @click="showModal4()">
              <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar examen
            </button>
          </div>


          <br>
          <br>


          <table class="table">
            <thead>
            <tr >
              <th>Titulo</th>
            </tr>
            </thead>
            <tbody v-for="exam in lessonsModule.exams" :key="exam.id">
            <tr>
              <td>{{ exam.title}}</td>
              <td>
                <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                        v-on:click="deleteExams(exam.id)">
                  Eliminar
                </button>
              </td>
            </tr>
            </tbody>

            <tbody v-if="lessonsModule.exams && lessonsModule.exams.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>


      <ExamsAdd ref="ExamAddComponent" @saveExam="saveExam"/>

      <!-- add exams-->
      <div class="container-fluid" v-if="isEdit">
        <!-- DataTales Example -->
        <div class="card shadow mb-4">
          <div id="app" class="container">
            <div class="div-lessons">
              <h3>Exámen Diagnóstico (opcional):</h3>
              <button class="btn btn-primary"  @click="showModal5()" v-if="!lessonsModule.examDiag">
                <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar exámen diagnóstico
              </button>
            </div>


            <br>
            <br>


            <table class="table">
              <thead>
              <tr >
                <th>Titulo</th>
              </tr>
              </thead>
              <tbody v-if="lessonsModule.examDiag">
              <tr>
                <td>{{ lessonsModule.examDiag.title}}</td>
                <td>
                  <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                          v-on:click="deleteExamDiag(lessonsModule.examDiag.id)">
                    Eliminar
                  </button>
                </td>
              </tr>
              </tbody>

              <tbody v-if="!lessonsModule.examDiag">
              <tr >
                <td colspan="2" class="td-nhd">No hay datos</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


        <ExamsAdd ref="ExamAddComponent2" @saveExam="saveExam" :type="'diagnostic'"/>



      </div>
      </div>
    <!-- /add exams-->

  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";
import LessonsAdd from "@/views/Admin/Components/Lessons/LessonsAdd.vue";
import ExamsAdd from "@/views/Admin/Components/Exams/ExamsAdd.vue";

export default {
  components: {ExamsAdd, LessonsAdd},
  data() {
    return {

      form: {
        title: '',
        description: '',
        longDescription: '',
        icon: '',
        iconName: '',
        examRequired: false,
        isPremium: false,
      },
      show: true,
      moduleId: null,
      isEdit: false,
      title: '',
      lecciones: [{ nombre: '' }],
      searchLessons: "",
      SearchPractices: "",
      searchSimulacrums: "",
      lessonsItems: [],
      simulacrumsItems: [],
      practices: [],
      lessonsModule: [],
      simulacrumsModule: [],
      selectedSectionId: null,
      editingSectionId: null,
      editingSectionTitle: '',
      /** Sections loaded from GET /modules/:id/sections so CRUD always has full list (including "Contenido"). */
      sectionsList: null,
    }
  },
  computed: {
    sectionsForDisplay() {
      if (!this.lessonsModule) return [];
      // Prefer sections from dedicated endpoint so "Contenido" and all sections always show in CRUD
      if (this.sectionsList && this.sectionsList.length > 0) {
        return this.sectionsList;
      }
      if (this.lessonsModule.sections && this.lessonsModule.sections.length > 0) {
        return this.lessonsModule.sections;
      }
      if (this.lessonsModule.lessons && this.lessonsModule.lessons.length > 0) {
        return [{ id: null, title: 'Contenido', lessons: this.lessonsModule.lessons }];
      }
      return [{ id: null, title: 'Contenido', lessons: [] }];
    },
  },
  methods: {

    loadPractices() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/practices/getPracticesListforAdd/" + this.moduleId, {
          params: {
            search: this.SearchPractices,
            modelName: "modules"
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.practices = response.data;

        })
        .catch((err) => {
          console.log(err.message);;
        });
    },
    loadExams() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/exams/getExamsListforAdd/" , {
          params: {
            search: this.searchExams,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.exams = response.data;

        })
        .catch((err) => {
          console.log(err.message);;
        });
    },
    loadSimulacrums() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/getSimulacrumsListforAdd/", {
          params: {
            search: this.searchSimulacrums
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.simulacrumsItems = response.data;

        })
        .catch((err) => {
          console.log(err.message);;
        });
    },
    onModalHide() {
      this.lessonsItems = [];
      this.simulacrumsItems = [];
      this.practices = [];
      this.searchLessons = '';
      this.searchSimulacrums = '';
    },
    deleteLesson(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta lección?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/lessons/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    deletePractice(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta práctica?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/practice/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    deleteExams(id) {
      if(!confirm("¿Estás seguro que deseas eliminar este Exámen?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/exam/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    deleteExamDiag(id) {
      if(!confirm("¿Estás seguro que deseas eliminar este exámen diagnóstico?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/examDiag/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    deleteSimulacrum(id) {
      if(!confirm("¿Estás seguro que deseas eliminar este simulacro?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/simuLacrums/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    showModal2(sectionId) {
      this.selectedSectionId = sectionId;
      this.$refs['lessonAddComponent'].showModal();
    },
    onSaveLesson(lessonId) {
      this.saveLesson(lessonId, this.selectedSectionId);
      this.selectedSectionId = null;
    },
    saveLesson(lessonId, sectionId) {
      this.moduleId = this.$route.params.id;
      var moduleId = parseInt(this.moduleId);
      const body = { moduleId, lessonId };
      if (sectionId != null && sectionId !== undefined && sectionId !== '') {
        body.sectionId = Number(sectionId);
      }
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/modules/saveLesson", body, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Lección Guardado."
          );
          console.log(result);
          this.$router.go();
        }).catch((err) => {
          if (err.response.data === 'duplicated') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Error al crear, Ya se ha agregado esta lección antes"
            );
            console.log(err.message);
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
             "Error al crear"
            );
            console.log(err.message);
          }
        });
    },
    savePractice(practiceId) {

      this.moduleId = this.$route.params.id;
      var moduleId = parseInt(this.moduleId);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/modules/savePractice", {
        'moduleId': moduleId  , 'practiceId': practiceId
      }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Práctica Guardada."
          );
          console.log(result);
          this.$router.go();
        }).catch((err) => {

        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.e(
          "Error al crear"
        );
        console.log(err.message);

      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    handleFilesUpload(e) {
      const file = e.target.files[0];
      this.form.iconName = URL.createObjectURL(file);
      this.getBase64(file).then((data) => (this.form.icon = data));
    },
    saveExam(data) {
      const examId = data.id;
      const type = data.typeExam;


      this.moduleId = this.$route.params.id;
      var moduleId = parseInt(this.moduleId);

      if (type && type === 'diagnostic') {
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/modules/saveExamDiag", {
          'moduleId': moduleId  , 'examId': examId
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Examen Guardado."
          );
          console.log(result);
          this.$router.go();
        }).catch((err) => {

          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Error al crear, es posible que este exámen ya esté asignado a otro curso"
          );
          console.log(err.message);

        });
      } else {
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/modules/saveExam", {
          'moduleId': moduleId  , 'examId': examId
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Examen Guardado."
          );
          console.log(result);
          this.$router.go();
        }).catch((err) => {
          if (err.response.data === 'duplicated') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Error al crear, Ya se ha agregado este Exames antes"
            );
            console.log(err.message);
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
             "Error al crear"
            );
            console.log(err.message);
          }
        });
      }

    },
    saveSimulacrum(simulacrumId) {

      this.moduleId = this.$route.params.id;
      var moduleId = parseInt(this.moduleId);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/modules/saveSimulacrum", {
        'moduleId': moduleId  , 'simulacrumId': simulacrumId
      }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 50000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Simulacro Guardado."
          );
          console.log(result);
          setTimeout(this.$router.go(), 3000);
        }).catch((err) => {
          if (err.response.data === 'duplicated') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Error al crear, Ya se ha agregado este simulacro antes"
            );
            console.log(err.message);
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
             "Error al crear"
            );
            console.log(err.message);
          }
        });
    },
    showModal() {
      this.$refs['my-modal'].show();
    },
    addSection() {
      const moduleId = parseInt(this.$route.params.id);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/modules/" + moduleId + "/sections", { title: 'Nueva sección' }, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }).then(() => {
        this.$toastr.s("Sección creada.");
        this.$router.go();
      }).catch((err) => {
        this.$toastr.e("Error al crear sección.");
        console.log(err.message);
      });
    },
    startEditSectionTitle(section) {
      this.editingSectionId = section.id;
      this.editingSectionTitle = section.title;
    },
    submitSectionTitle(sectionId) {
      axios.put(import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/sections/" + sectionId, { title: this.editingSectionTitle }, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }).then(() => {
        this.$toastr.s("Sección actualizada.");
        this.editingSectionId = null;
        this.$router.go();
      }).catch((err) => {
        this.$toastr.e("Error al actualizar sección.");
        console.log(err.message);
      });
    },
    deleteSectionConfirm(sectionId) {
      if (!confirm("¿Eliminar esta sección? Las lecciones se moverán a la primera sección restante.")) return;
      axios.delete(import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/sections/" + sectionId, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }).then(() => {
        this.$toastr.s("Sección eliminada.");
        this.$router.go();
      }).catch((err) => {
        this.$toastr.e("Error al eliminar sección.");
        console.log(err.message);
      });
    },
    showModal3() {
      this.$refs['my-modal2'].show();
    },
    showModal4() {
      this.$refs['ExamAddComponent'].showModal();
    },
    showModal5() {
      this.$refs['ExamAddComponent2'].showModal();
    },
    onSubmit(event) {
      event.preventDefault()
      let loader = this.$loading.show({});
      this.form.examRequired = this.form.examRequired === true || this.form.examRequired === 'true';
      this.form.isPremium = this.form.isPremium === true || this.form.isPremium === 'true';
      if (this.isEdit) {
        axios.put(import.meta.env.VITE_API_BASE_URL + "/api/modules/edit/" + this.moduleId , this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Curso Editado."
          );
          console.log(result);
          loader.hide();
          router.push({ path: `/admin-panel/cursos` })
        }).catch((err) => {
          if (err.response.data.response === 'duplicated') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Ya se ha creado un curso con este nombre"
            );
            console.log(err.message);
            loader.hide();
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Error al editar"
            );
            console.log(err.message);
            loader.hide();
          }
        });
      } else {
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/modules/save", this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Curso Guardado."
          );
          console.log(result);
          loader.hide();
          router.push({ path: `/admin-panel/cursos` })
        }).catch((err) => {
          if (err.response.data.response === 'duplicated') {
            this.$toastr.defaultTimeout = 5000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Ya se ha creado un curso con este nombre"
            );
            console.log(err.message);
            loader.hide();
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
             "Error al crear"
            );
            console.log(err.message);
            loader.hide();
          }
        });
      }
    },
    onReset(event) {
      event.preventDefault()
    },
  },
  mounted() {
    if (this.$route.params.id) {
      let loader = this.$loading.show({});
      this.moduleId = this.$route.params.id;
      this.isEdit = true;
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log("oliver: " + response.data.examRequired);
          this.form.title = response.data.title;
          this.form.description = response.data.description;
          this.form.longDescription = response.data.longDescription;
          this.form.icon = response.data.icon;
          this.form.lessons = response.data.lessons;
          this.examRequired = response.data.examRequired;
          this.form.isPremium = response.data.isPremium;
          if(response.data === '') {
            console.log(response.data);
            this.lessonsModule = [];
            this.simulacrumsModule = [];
            this.sectionsList = null;
            loader.hide();
            return;
          }
          let data= response.data;

          /*data.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
          });*/

          this.lessonsModule = data;
          this.simulacrumsModule = data;
          // Load sections from dedicated endpoint so CRUD shows all sections (including default "Contenido")
          return axios.get(
            import.meta.env.VITE_API_BASE_URL + "/api/modules/" + this.moduleId + "/sections",
            { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
          ).then((sectionsRes) => {
            this.sectionsList = sectionsRes.data || [];
          }).catch(() => {
            this.sectionsList = null;
          });
        }).then(() => {}).catch((err) => {
          console.log(err.message);
        }).finally(() => {
          loader.hide();
        });
    }
  },
  beforeMount() {

  },
}
</script>
